// extracted by mini-css-extract-plugin
export default {"btop":"_7351cb82cd _2e9f95d08d f19fb64d87","icon":"_4e684798cd _97639c2c0d","btoppink":"b4f66184d4 _9a758a692b"};